export default function AddButton(props: { href: string }) {
	return (
		<a
			href={props.href}
			className="btn btn-success btn-circle btn-sm addButton"
			title="Add New"
		>
			<i className="fas fa-plus-circle"></i>
		</a>
	);
}
